module.exports = __webpack_public_path__ + "static/media/image_b2c_bg.db04b4d5.png";